import React from 'react';


const indicationCopy = {
 mt: {
   indicationtitle: () => (
     <>
       Indication for <span className="blue-highlight">WELIREG</span> in
       combination with <span className="green-highlight">KEYTRUDA</span> or{' '}
       <span className="green-highlight">KEYTRUDA</span>{' '}
       <span className="purple-highlight">QLEX</span>
     </>
   ),
   indicationBody: () =>
     'WELIREG, in combination with KEYTRUDA or KEYTRUDA QLEX, is indicated for the adjuvant treatment of adult patients with renal cell carcinoma with a clear cell component (ccRCC) at intermediate-high or high risk of recurrence following nephrectomy, or following nephrectomy and resection of metastatic lesions.',
   title: () => (
     <span className="blue-highlight">Indications for WELIREG</span>
   ),
   body: () => (
     <>
       <p>
         WELIREG is indicated for the treatment of adult patients with advanced
         renal cell carcinoma with a clear cell component (ccRCC) following a
         programmed death receptor-1 (PD-1) or programmed death-ligand 1
         (PD-L1) inhibitor and a vascular endothelial growth factor tyrosine
         kinase inhibitor (VEGF-TKI).
       </p>
       <p>
         WELIREG is indicated for the treatment of adult patients with von
         Hippel-Lindau (VHL) disease who require therapy for associated renal
         cell carcinoma (RCC), central nervous system (CNS) hemangioblastomas,
         or pancreatic neuroendocrine tumors (pNET), not requiring immediate
         surgery.
       </p>
       <p>
         WELIREG is indicated for the treatment of adult and pediatric patients
         12 years and older with locally advanced, unresectable, or metastatic
         pheochromocytoma or paraganglioma (PPGL).
       </p>
     </>
   ),
 },
};


export default indicationCopy;
